/* eslint-disable */
export const STUDENT_LIST = 'dual-meet/STUDENT_LIST';



// WEBPACK FOOTER //
// ./src/store/modules/dual-meet/types.js